import type { RenderEngine } from './types';

/**
 * Holds the one live engine instance so commands can reach it without prop
 * drilling. The UI creates the engine (CanvasStage) and registers it here.
 *
 * The renderer itself is deliberately *not* re-exported from this module: a
 * static re-export would pull Fabric into the boot chunk for every importer
 * that only wants `getEngine`. Load it with `loadEngine()` instead.
 */
let active: RenderEngine | null = null;

export function setEngine(engine: RenderEngine | null): void {
  active = engine;
}

export function getEngine(): RenderEngine | null {
  return active;
}

export * from './types';
